// profile-dropdown.component.ts
import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-profile-dropdown',
    template: `
    <div class="col-12 circle dropdown">
      <img class="dropdown-toggle profile_img" 
           [src]="profileImage"
           [alt]="imageAlt"
           [class.rotate]="isRotated"
           id="dropdownMenuButton"
           data-toggle="dropdown" 
           aria-haspopup="true" 
           aria-expanded="false"
           (mouseenter)="onMouseEnter()" 
           (mouseleave)="onMouseLeave()">
      
      <div class="dropdown-menu dropdown-menu-right py-2" 
           aria-labelledby="dropdownMenuButton">
        
        <div class="col-12 px-3 py-2 border-bottom mb-2 d-md-none">
          <p class="mb-0 font-weight-bold" style="color: #151c43; font-size: calc(var(--font-medium));">{{userName}}</p>
          <p class="mb-0 text-muted" style="font-size: calc(var(--font-small));">{{companyName}}</p>
        </div>

        <div class="col-12 dropdown-item" (click)="onMenuClick('profile')"
             style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Profile" | translate }}
        </div>
        
        <div *ngIf="showSubscription" class="col-12 dropdown-item" (click)="onMenuClick('subscription')"
             style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Subscription" | translate }}
        </div>
        
        <div class="col-12 dropdown-item" (click)="onMenuClick('documentation')"
             style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Documentation" | translate }}
        </div>
        
        <div class="col-12 dropdown-item" (click)="onMenuClick('helpguide')"
             style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Help Guide" | translate }}
        </div>
        
        <div class="col-12 dropdown-item mt-1" (click)="onMenuClick('notification')"
             style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Notification" | translate }}
        </div>
        
        <div class="dropdown-divider" *ngIf="showLogout" style="margin: 8px 0;"></div>
        
        <div *ngIf="showLogout" class="col-12 dropdown-item text-danger" (click)="onMenuClick('logout')"
             style="line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
          {{ "common.Logout" | translate }}
        </div>
      </div>
    </div>
  `,
    styles: [`
    .circle {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      cursor: pointer;
    }
    
    .profile_img {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 2px solid white;
      box-sizing: border-box;
      transition: border-color 0.3s ease;
    }
    
    .profile_img:hover {
      border-color: #8d979b;
      transition: border-color 0.3s ease;
    }
    
    .rotate {
      border-color: #8d979b;
    }
    
    .dropdown-item:focus {
      background-color: transparent;
    }
    
    .dropdown-item:hover {
      background-color: #d8d8d8;
      transition: 0.3s ease all;
    }
    
    .dropdown-toggle::after {
      display: none;
    }
  `]
})
export class ProfileDropdownComponent {
    @Input() profileImage: string = '../../assets/avatar-cartoon.png';
    @Input() imageClass: string = 'profile_img';
    @Input() imageAlt: string = 'profile';
    @Input() showSubscription: boolean = false;
    @Input() showLogout: boolean = false;
    @Input() userName: string = '';
    @Input() companyName: string = '';

    @Output() menuItemClicked = new EventEmitter<string>();
    @Output() mouseEntered = new EventEmitter<boolean>();
    @Output() mouseLeft = new EventEmitter<boolean>();

    isRotated = false;

    onMenuClick(action: string) {
        this.menuItemClicked.emit(action);
    }

    onMouseEnter() {
        this.isRotated = true;
        this.mouseEntered.emit(true);
    }

    onMouseLeave() {
        this.isRotated = false;
        this.mouseLeft.emit(false);
    }
}
